import React, { useState, useEffect } from "react";
import { Page, Grid, Card, Table, Button } from "tabler-react";


import SiteWrapper from "../../SiteWrapper";
import * as tagServices from '../../store/services/tagServices';



function Tags(props) {


    const [ loading, setLoading ] = useState(false);
    const [ tags, setTags ] = useState([]);
    useEffect(() => {
        setLoading(true);

        tagServices
            .getTags()
            .then(res => {
                const data = JSON.parse(res.data);
                
                setTags(data.data);
                setLoading(false);
            })
            .catch(err => setLoading(false));
    }, []);

    return (
        <SiteWrapper loading={loading}>
            <Page.Content>
                <div className="page-header d-flex justify-content-between">
                    <h1 className="page-title">Tags</h1>

                    <Button 
                        className="btn-mm d-flex justify-content-center align-items-center"
                        onClick={() => {
                            props.history.push("/tags/0");
                        }}
                    >
                        Add New
                        <svg width="9" height="10" viewBox="0 0 9 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4.5 1.5V8.5" stroke="white" strokeWidth="2" strokeLinecap="square"/>
                            <path d="M8 5H1" stroke="white" strokeWidth="2" strokeLinecap="square"/>
                        </svg>
                    </Button>
                </div>
                <Grid.Row>
                    <Grid.Col>
                        <Card>
                            <Card.Header className="d-flex justify-content-between">
                                <Card.Title>Tags</Card.Title>
                            </Card.Header>
                        {tags.length > 0 ?
                            <Table
                            cards={true}
                            striped={true}
                            responsive={true}
                            className="table card-table table-vcenter datatable"
                            >
                            <Table.Header>
                                <Table.Row>
                                <Table.ColHeader>Tag Name</Table.ColHeader>
                                <Table.ColHeader />
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {tags.map((tag, key) => (
                                <Table.Row key={key}>
                                    <Table.Col>{ tag?.tag }</Table.Col>
                                    <Table.Col>
                                        <Button
                                            color="secondary"
                                            onClick={() => {
                                                props.history.push("/tags/" + tag.id);
                                            }}
                                        >
                                            Edit
                                        </Button>
                                    </Table.Col>
                                </Table.Row>
                                ))}
                            </Table.Body>
                            </Table> :
                            <Card.Body className='align-items-center justify-content-center'>
                            <h4 className="h4 mt-4 text-center" style={{ color: '#000', marginBottom: 20 }}>
                                No Tag
                            </h4>
                            <div className="detail mb-5">You haven’t made any tag yet.</div>
                            </Card.Body>
                        }
                        </Card>
                    </Grid.Col>
                </Grid.Row>
            </Page.Content>
        </SiteWrapper>
    )
}

export default Tags;